import { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "../App";

let cache = null;
let inflight = null;
const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) inflight = axios.get(`${API}/me/pages`, { withCredentials: true }).then((r) => (cache = r.data.pages || [])).catch(() => (cache = []));
  return inflight;
};

// Is the signed-in user the owner of this page (or an admin)? Drives the "＋ Add a song / Add shows" CTAs on artist pages.
export const usePageOwner = (slug, kind = "music") => {
  const { user } = useAuth();
  const [owner, setOwner] = useState(false);
  useEffect(() => {
    if (!user || !slug) { setOwner(false); return; }
    if (user.role === "admin") { setOwner(true); return; }
    let alive = true;
    load().then((pages) => { if (alive) setOwner(pages.some((p) => p.id === slug && (kind === "any" || p.kind === kind))); });
    return () => { alive = false; };
  }, [user, slug, kind]);
  return { isOwner: owner, verified: !!user && (user.role === "admin" || (user.is_anonymous ? !!user.recovery_email_verified : user.email_verified !== false)) };
};
